module.exports = __webpack_public_path__ + "static/img/WATCH_GT2e.e469f141.png";